exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#privacyPolicy > h3 {\n  color: #4f4f51;\n  display: block;\n  font-size: 1.75em;\n  margin-bottom: 0.5em;\n  font-weight: bold;\n  line-height: 1.2;\n}\n#privacyPolicy > p, li {\n  color: #4f4f51;\n  font-size: 18px !important;\n  line-height: 1.5 !important;\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n#privacyPolicy > ul {\n  list-style: disc;\n  padding-left: 40px;\n  margin-bottom: 1rem;\n}\n#footnote {\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  color: #888;\n  width: 100%;\n}", ""]);

// exports
